// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  name: "dev",
  production: false,
  //bsaRequestToolConfigUri: "https://dh-public-web-assets.s3.amazonaws.com/test/online-forms/shared_ui/v1.0.0.4/bsa-request-tool/config.json",
  apiGatewayUri: "https://vh8qvz8kk2.execute-api.us-east-1.amazonaws.com/test",
  apiUri: "https://api.innovation.dev.deephavenmortgage.com",
  auth: {
    region: "us-east-1",
    userPoolId: "us-east-1_ELSsePzvh",
    userPoolWebClientId: "1rnsdo1ifb9iar5n0gctvj111b",
    domain: "dev-dh-innovation.auth.us-east-1.amazoncognito.com",
    scopes: [
      "phone", 
      "email", 
      "profile", 
      "openid",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: "https://innovation.dev.deephavenmortgage.com/oauth2/login",
    redirectSignOut: "https://innovation.dev.deephavenmortgage.com/dashboard"
  },
  zoomInfoScriptSrc: "",
  systemUnderMaintenance: false,
  adminEmailDomains: ["deephavenmortgage.com", "ramp51.com"],
  idleTimeoutMinutes: 5,
  encompassInstanceId: "TEBE11175611"
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
